// Module
var code = "<template> <canvas ref=\"canvasElement\"></canvas> </template>";
// Exports
export default code;